/* eslint-disable no-unreachable */

// ----------------------------------------------------------------------
import styles from './Auth.module.css';
import Logo from '../logo/appLogo';
import { NavLink as RouterLink } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useContext, useEffect, useRef, useState } from 'react';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import toast from 'react-hot-toast';
import { useNavigate, useLocation } from 'react-router-dom';
import { BaseUrlContext } from 'src/context/BaseUrlContext';
import bus from 'src/bus';
import PlacesAutocompleteComponent from 'src/components/placeAutoComplete';
import { useApiKeys } from 'src/hooks/useApiKeys';
import PlacesAutocomplete, {
  geocodeByAddress,
  geocodeByPlaceId,
  getLatLng,
} from 'react-places-autocomplete';
import { GoogleLogin } from 'react-google-login';
import LiveSelect from 'react-select';

export default function RegisterPage() {
  let navigate = useNavigate();
  // const location = useLocation()
  const [category, setCategory] = useState('');
  const [StoreID, setStoreID] = useState(false);
  const [StoreIDValue, setStoreIDValue] = useState('');
  const [email, setEmail] = useState('');
  const [storeName, setStoreName] = useState('');
  const [location, setLocation] = useState({ latitude: '', longitude: '' });
  const [storeAddress, setStoreAddress] = useState('');
  const [storePhone, setStorePhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirm_password, setCPassword] = useState('');
  const [agree, setAgree] = useState(false);
  const [doesNotMath, setDoesNotMath] = useState(false);
  const [signUpError, setSignUpError] = useState(null);
  const [response, setResponse] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const [showText, setShowText] = useState(false);
  const [showText1, setShowText1] = useState(false);
  const [store_address, setAddr] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [currentLocationCheck, setCurrentLocationCheck] = useState(false);
  const baseUrl = useContext(BaseUrlContext);
  const [pageContent, setPageContent] = useState(
    'Track and monitor <br /> your customers on <br /> a single dashboard'
  );
  const [pageDescription, setDescription] = useState(
    '  Make informed sales decisions by monitoring consumer <br /> behaviours, brand acceptance and market performance.'
  );
  const [bg, setBg] = useState('/assets/happyMan.jpg');
  const prevCategoryRef = useRef('');
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [locationDisabled, setLocationDisabled] = useState(false);
  const [addressResults, setAddressResults] = useState([]);
  const [selectedLocationName, setSelectedLocationName] = useState(null);
  const [onBoardedBy, setOnBordedBy] = useState('self');
  const [onBoardedByName, setOnBordedByName] = useState('');
  const [country, setCountry] = useState('');
  const [state, setState] = useState('');
  const [states, setStates] = useState([]);
  const [bankCode, setBankCode] = useState('');
  const [bankName, setBankName] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [accountName, setAccountName] = useState('');
  const [banks, setBanks] = useState([]);
  const [isResolvingAccount, setIsResolvingAccount] = useState(false);
  const [selectedBank, setSelectedBank] = useState(null);
  const [productCategories, setProductCategories] = useState([]);
  const [selectedProductCategories, setSelectedProductCategories] = useState([]);
  const [isLoadingCategories, setIsLoadingCategories] = useState(false);

  // Fallback categories if API returns empty data
  const fallbackCategories = [
    // { _id: 'beverages', category_name: 'Beverages' },
    // { _id: 'table-water', category_name: 'Table water' },
    // { _id: 'snacks', category_name: 'Snacks' },
    // { _id: 'home-appliances', category_name: 'Home appliances' },
    // { _id: 'games', category_name: 'Games' },
    // { _id: 'beauty', category_name: 'Beauty' },
    // { _id: 'perfumes', category_name: 'Perfumes' },
    // { _id: 'electronics', category_name: 'Electronics' },
    // { _id: 'clothing', category_name: 'Clothing & Fashion' },
    // { _id: 'food', category_name: 'Food & Groceries' },
  ];
  const apiKeys = useApiKeys();

  const hardcodedCountries = [
    { name: 'Nigeria', states: ['Lagos', 'Abuja', 'Kano', 'Rivers'] },
    { name: 'Kenya', states: ['Nairobi', 'Mombasa', 'Kisumu', 'Nakuru'] },
    { name: 'Egypt', states: ['Cairo', 'Giza', 'Alexandria', 'Aswan'] },
    { name: 'Brazil', states: ['São Paulo', 'Rio de Janeiro', 'Bahia', 'Paraná'] },
    { name: 'Argentina', states: ['Buenos Aires', 'Córdoba', 'Mendoza', 'Santa Fe'] },
    { name: 'Colombia', states: ['Bogotá', 'Medellín', 'Cali', 'Barranquilla'] },
    { name: 'United Kingdom', states: ['England', 'Scotland', 'Wales', 'Northern Ireland'] },
    { name: 'Germany', states: ['Bavaria', 'Berlin', 'Hamburg', 'Hesse'] },
    { name: 'France', states: ['Île-de-France', 'Provence', 'Normandy', 'Brittany'] },
  ];

  const notify = () => toast.success('Registration successful .');
  const notifyError = () =>
    toast.error("That didn't work please try again later .");

  useEffect(() => {
    const fetchBanks = async () => {
        try {
            const banksApi = await fetch('https://api.paystack.co/bank');
            const banksJson = await banksApi.json();
            if (banksJson.status) {
                setBanks(banksJson.data);
            }
        } catch(e) {
            console.error("Could not fetch banks", e);
        }
    };
    fetchBanks();
  }, []);

  useEffect(() => {
    const fetchProductCategories = async () => {
      if (category === 'brand') {
        setIsLoadingCategories(true);
        try {
          const url = `${baseUrl}/product-category/all`;
          console.log('Fetching product categories from:', url);
          
          // Use the public endpoint for product categories
          const response = await axios.get(url);
          console.log('Product categories response:', response.data);
          
          if (response.data && response.data.success && response.data.data) {
            // Public endpoint returns: { success: true, code: 200, data: [...] }
            const categories = response.data.data || [];
            console.log('Setting product categories:', categories);
            
            if (categories.length > 0) {
              setProductCategories(categories);
            } else {
              console.log('API returned empty categories, using fallback categories');
              setProductCategories(fallbackCategories);
            }
          } else {
            console.warn('Unexpected response format, using fallback categories:', response.data);
            setProductCategories(fallbackCategories);
          }
        } catch (error) {
          console.error('Could not fetch product categories', error);
          console.error('Error details:', error.response?.data);
          console.log('Using fallback categories due to API error');
          setProductCategories(fallbackCategories);
        } finally {
          setIsLoadingCategories(false);
        }
      } else {
        // Reset categories when not a manufacturer
        setProductCategories([]);
        setSelectedProductCategories([]);
      }
    };
    fetchProductCategories();
  }, [category, baseUrl]);

  useEffect(() => {
    const resolveAccountName = async () => {
      if (accountNumber.length === 10 && bankCode) {
        setIsResolvingAccount(true);
        try {
          const response = await fetch(
            `https://api.paystack.co/bank/resolve?account_number=${accountNumber}&bank_code=${bankCode}`,
            {
              headers: {
                Authorization: `Bearer ${apiKeys.PASTACK.SECRET_KEY}`,
              },
            }
          );
          const data = await response.json();
          if (data.status) {
            setAccountName(data.data.account_name);
          } else {
            setAccountName('');
            toast.error(data.message);
          }
        } catch (error) {
          toast.error("Couldn't resolve account name");
        } finally {
          setIsResolvingAccount(false);
        }
      } else {
        setAccountName('');
      }
    };

    const handler = setTimeout(() => {
      if (apiKeys.PASTACK?.SECRET_KEY) {
        resolveAccountName();
      }
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [accountNumber, bankCode]);

  useEffect(() => {
    if (category !== '' && category !== prevCategoryRef.current) {
      if (category === 'brand') {
        setPageContent(
          'Track and monitor <br /> your customers on <br /> a single dashboard'
        );
        setDescription(
          'Make informed sales decisions by monitoring consumer <br /> behaviours, brand acceptance and market performance.'
        );
        setBg('/assets/happyMan.jpg');
      } else if (['kiosk', 'mini_mart', 'supermarket', 'chain_store'].includes(category)) {
        setPageContent(
          ' Buy, sell and monitor <br />  your customers on a <br /> single platform'
        );
        setDescription(
          ' Make purchases and keep track of all your business transactions in one <br /> convenient place.'
        );
        setBg('/assets/retailerBg.svg');
      }
      prevCategoryRef.current = category;
    }
  }, [category]);

  const handleChange = (event) => {
    let value = event.target.value;
    setCategory(value);
  };

  const handleOnboardedName = (event) => {
    let value = event.target.value;
    setOnBordedByName(value);
  };

  const handleCountryChange = (event) => {
    const selectedCountryName = event.target.value;
    setCountry(selectedCountryName);
    const selectedCountry = hardcodedCountries.find(c => c.name === selectedCountryName);
    setStates(selectedCountry ? selectedCountry.states : []);
    setState(''); // Reset state when country changes
  };

  const handleBankChange = (selectedOption) => {
    setSelectedBank(selectedOption);
    if (selectedOption) {
      setBankCode(selectedOption.value);
      setBankName(selectedOption.label);
    } else {
      setBankCode('');
      setBankName('');
    }
  };

  const handleProductCategoryChange = (selectedOptions) => {
    setSelectedProductCategories(selectedOptions || []);
  };

  const handleChangeOnboarded = (event) => {
    let value = event.target.value;
    setOnBordedBy(value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };
  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };
  const handleStoreNameChange = (event) => {
    setStoreName(event.target.value);
  };
  const handleStoreAddressChange = (value) => {
    setStoreAddress(value);
    setAddr(value);
    setCurrentLocationCheck(false);
  };
  const handleStorePhoneChange = (event) => {
    setStorePhone(event.target.value);
  };
  const handleCPasswordChange = (event) => {
    setCPassword(event.target.value);
  };
  const setAddress = (e) => {
    setAddr(e);
  };
  const handleUseLiveLocation = () => {
    setIsLoading(true);
    setCurrentLocationCheck(true);

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          setLocation({ latitude, longitude });

          if (latitude !== null && longitude !== null) {
            fetch(
              `https://maps.googleapis.com/maps/api/geocode/json?address=${latitude},+${longitude}&key=AIzaSyCvH_nDKUVAcmjtKEbv-_YDY9rVbGqg4VQ`
            )
              .then((response) => response.json())
              .then((data) => {
                if (data.results && data.results.length > 0) {
                  const uniqueAddresses = [];
                  data.results.forEach((result) => {
                    if (!uniqueAddresses.includes(result.formatted_address)) {
                      uniqueAddresses.push(result.formatted_address);
                    }
                  });
                  setAddressResults(uniqueAddresses);
                  if (uniqueAddresses.length > 0) {
                    setAddr(uniqueAddresses[0]);
                    setStoreAddress(uniqueAddresses[0])
                  }
                } else {
                  toast.error('Could not find any addresses for your location.');
                  setCurrentLocationCheck(false);
                }
              })
              .catch((error) => {
                toast.error('Failed to fetch address from Google Maps.');
                setCurrentLocationCheck(false);
              })
              .finally(() => {
                setIsLoading(false);
              });
          } else {
            toast.error('Could not retrieve your coordinates.');
            setIsLoading(false);
            setCurrentLocationCheck(false);
          }
        },
        (error) => {
          toast.error(`Geolocation error: ${error.message}`);
          setIsLoading(false);
          setCurrentLocationCheck(false);
        }
      );
    } else {
      toast.error('Geolocation is not supported by this browser.');
      setIsLoading(false);
      setCurrentLocationCheck(false);
    }
  };

  const handleManualLocation = () => {
    setCurrentLocationCheck(false);
  }

  const handleSelect = async (value) => {
    const results = await geocodeByAddress(value);
    const { lat, lng } = await getLatLng(results[0]);
    setLocation({
      latitude: lat,
      longitude: lng,
    });
    setAddr(value);
  };

  const handlePasteLocation = () => {
    if (locationDisabled) {
      alert('Please enable browser location to proceed.');
    }

    setLocation(selectedLocation);
    // setAddr(selectedLocationName)
    setCurrentLocationCheck(!currentLocationCheck);

    if (addressResults.length > 0) {
      setAddr(addressResults[0]);
    }
  };
  const handleChange2 = (e) => {
    setAgree(!agree);
  };

  const changeType = () => {
    setShowText(!showText);
  };
  const changeType1 = () => {
    setShowText1(!showText1);
  };

  const handleAddressChange = (e) => {
    setAddr(e.target.value);
  };

  useEffect(() => {
    // Access the query parameters from the location object
    const searchParams = new URLSearchParams(location?.search);
    const storeID = searchParams.get('StoreID');

    // Do something with the storeID
    if (storeID) {
      setStoreID(!StoreID);
      setStoreIDValue(storeID);
    }
  }, [location]);

  function HandleFormSubmit(e) {
    e.preventDefault();

    if (confirm_password !== password) {
      setDoesNotMath(true);
      return;
    }

    if (password.length < 8) {
      setSignUpError('Password must be at least 8 characters long');
      return;
    }

    if (category === 'brand' && selectedProductCategories.length === 0) {
      setSignUpError('Please select at least one product category for your business');
      return;
    }

    setSignUpError(null);
    let payload = {
      merchant_type: StoreID ? 'shop' : category,
      email,
      password,
      confirm_password,
      latitude: String(location.latitude),
      longitude: String(location.longitude),
      onboarded_by: onBoardedBy,
      onboarder_id: onBoardedBy === 'self' ? email : onBoardedByName,
    };

    if (category === 'brand') {
      payload.business_name = storeName;
      payload.business_address = storeAddress;
      payload.business_phone_number = storePhone;
      payload.country = country;
      payload.state = state;
      if (bankName) payload.bank_name = bankName;
      if (accountNumber) payload.bank_account_number = accountNumber;
      if (accountName) payload.bank_account_name = accountName;
      if (selectedProductCategories.length > 0) {
        payload.product_categories = selectedProductCategories.map(cat => cat.value);
      }
    } else {
      payload.store_name = storeName;
      payload.store_address = storeAddress;
      payload.store_phone_number = storePhone;
      payload.country = country;
      payload.state = state;
      if (bankName) payload.store_bank_name = bankName;
      if (accountNumber) payload.store_account_number = accountNumber;
      if (accountName) payload.store_account_name = accountName;
    }

    if (StoreID) {
      payload.store_id = StoreIDValue;
    }

    const fetchData = async () => {
      try {
        setIsPending(true);
        // Make the API request
        const res = await axios({
          method: 'POST',
          url: `${baseUrl}/merchant/create`,
          data: payload,
          headers: {
            Authorization: `x-auth-token ${localStorage.getItem('token')}`,
          },
        });
        localStorage.setItem('e', email);
        localStorage.setItem('mt', payload.merchant_type);

        setResponse(res.data.message);
        bus.emit('email', email);
        setPassword('');
        setCPassword('');
        setEmail('');
        setCategory('manufacturer');
        notify();
        localStorage.removeItem('onRegister');
        localStorage.removeItem('storeID');
        setTimeout(() => {
          navigate('/verify_email');
        }, 2000);
      } catch (error) {
        const rawMessage = error.response?.data?.message;
        const displayMessage = typeof rawMessage === 'string' ? rawMessage : JSON.stringify(rawMessage);
        setSignUpError(displayMessage || "An error occurred");
        toast.error("That didn't work please try again later .");
      } finally {
        setIsPending(false);
      }
    };
    fetchData(true);
  }

  const TandC = () => {
    localStorage.setItem(
      'onRegister',
      JSON.stringify({
        email: email,
        password: password,
        confirm_password: confirm_password,
        category: category,
      })
    );
    if (StoreID) {
      localStorage.setItem('storeID', JSON.stringify(StoreIDValue));
    }
    navigate('/privacy-policy');
  };
  useEffect(() => {
    const regValue = localStorage.getItem('onRegister')
      ? JSON.parse(localStorage.getItem('onRegister'))
      : null;
    if (regValue) {
      setCategory(regValue.category);
      setEmail(regValue.email);
      setPassword(regValue.password);
      setCPassword(regValue.confirm_password);
    }
  }, []);

  const responseGoogle = (response) => {
    console.log(response);
    // Handle the response here
  };

  return (
    <div className={`row ${styles.sav}`}>
      <div className="col-md-6 d-none d-md-block">
        <div
          className={styles.bg}
          style={{
            backgroundImage: `linear-gradient(209.36deg, rgba(175, 53, 133, 0.75) 0%, rgba(19, 1, 34, 0.75) 100%), url(${category === 'brand'
              ? '/assets/happyMan.jpg'
              : '/assets/retailerBg.svg'
              })`,
            backgroundPosition: 'top center',
          }}
        >
          <img className={styles.star} src="/assets/Stars.svg" alt="stars" />
          <div className={styles.content}>
            <h5
              className={`${styles.header_text}`}
              dangerouslySetInnerHTML={{ __html: pageContent }}
            ></h5>
            <p dangerouslySetInnerHTML={{ __html: pageDescription }}></p>
            <div className={styles.icon_n_text}>
              <img
                className={styles.icons}
                src="/assets/Avatars.svg"
                alt="avatars"
              />
              <span style={{ color: '#EAECF0' }}>Join 40,000+ users</span>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-6 ">
        <Logo />
        <div className={`${styles.sign_up} container`}>
          <form onSubmit={HandleFormSubmit}>
            <h4
              className="mb-4"
              style={{
                fontSize: '36px',
                fontWeight: '600',
                color: '#111827',
              }}
            >
              Sign up
            </h4>
            {signUpError && (
              <Alert
                style={{
                  border: '1px solid red',
                }}
                severity="error"
              >
                {signUpError}
              </Alert>
            )}
            {response && (
              <Alert
                style={{
                  border: '1px dotted gray',
                }}
                severity="success"
              >
                {response}
              </Alert>
            )}
            {!StoreID && (
              <div className="my-4 inputs_n_label">
                <label htmlFor="s">Business Category</label>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={category}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  displayEmpty
                  required
                >
                  <MenuItem value="" disabled>
                    Select Business Category
                  </MenuItem>
                  <MenuItem value={'brand'}>Manufacturer</MenuItem>
                  <MenuItem value={'kiosk'}>Kiosk</MenuItem>
                  <MenuItem value={'mini_mart'}>Ministore</MenuItem>
                  <MenuItem value={'supermarket'}>Supermarket</MenuItem>
                </Select>
              </div>
            )}

            <div className="mb-3">
              <label htmlFor="businessPhone" className="my-2">
                Onboarded by*
              </label>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={onBoardedBy}
                onChange={handleChangeOnboarded}
                fullWidth
                size="small"
                displayEmpty
              >
                <MenuItem value={'self'}>Myself</MenuItem>
                <MenuItem value={'agent'}>Agent</MenuItem>
              </Select>
            </div>

            {onBoardedBy === 'agent' && (
              <div className="mb-3">
                <label htmlFor="agentCodeName" className="my-2">
                  Agent code/Name
                </label>
                <TextField
                  id="agentCodeName"
                  placeholder="Enter agent code or name"
                  size="small"
                  type="text"
                  value={onBoardedByName}
                  onChange={handleOnboardedName}
                  fullWidth
                />
              </div>
            )}

            <div className="my-4 inputs_n_label">
              <label htmlFor="email">Email</label>
              <TextField
                type="email"
                value={email}
                onChange={handleEmailChange}
                id="email"
                placeholder={'Joe@shoprite.com'}
                size="small"
                fullWidth
              />
              {/* <input   id='email' className='form-control' placeholder='' /> */}
            </div>
            
            <div className="my-4 inputs_n_label">
              <label htmlFor="store_name">{category === 'brand' ? 'Business Name' : 'Store Name'}</label>
              <TextField
                type="text"
                value={storeName}
                onChange={handleStoreNameChange}
                id="store_name"
                placeholder={category === 'brand' ? 'Your Business Name' : 'shoprite'}
                size="small"
                fullWidth
              />
            </div>
            {/* <div className='my-4 inputs_n_label'>
              <label htmlFor='store_address'>Store Addres34</label>
              <TextField
                type='text'
                value={storeAddress}
                onChange={handleStoreAddressChange}
                id="store_address"
                placeholder={"#1, street name, nearest bustop, state Country."}
                size="small"
                fullWidth
              />
            </div> */}

            <PlacesAutocomplete
              value={store_address}
              onChange={handleStoreAddressChange}
              onSelect={handleSelect}
            >
              {({
                getInputProps,
                suggestions,
                getSuggestionItemProps,
                loading,
              }) => (
                <div>
                  <div className="my-4 inputs_n_label">
                    <label htmlFor="loc">{category === 'brand' ? 'Business Address' : 'Store Address'}</label>
                    <div
                      className={`${styles.syl}`}
                      style={{ position: 'relative', width: '210px' }}
                    >
                      {!currentLocationCheck && (
                        <p
                          className="mt-2"
                          onClick={handleUseLiveLocation}
                          style={{ cursor: 'pointer', fontSize: '15px' }}
                        >
                          <FmdGoodIcon /> Use My Current Location
                          {isLoading && (
                            <CircularProgress
                              className="ml-1 mt-1"
                              style={{ color: '#53138D' }}
                              size="0.8rem"
                            />
                          )}
                        </p>
                      )}
                      {currentLocationCheck && (
                        <p
                          className="mt-2"
                          onClick={handleManualLocation}
                          style={{ cursor: 'pointer', fontSize: '15px' }}
                        >
                          <FmdGoodIcon /> Manual Location (Edit)
                        </p>
                      )}
                    </div>

                    {currentLocationCheck && (
                      <div className={`${styles.syl} d-flex mt-0`}>
                        <FormControlLabel
                          className="m-0"
                          value={store_address}
                          checked
                          control={<Radio />}
                        />
                        <Select
                          id="state"
                          fullWidth
                          size="small"
                          value={store_address}
                          required
                          onChange={handleAddressChange}
                        >
                          {addressResults.map((address, index) => (
                            <MenuItem key={index} value={address}>
                              {address}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    )}
                    {!currentLocationCheck && (
                      <TextField
                        id="loc"
                        placeholder="Input your location"
                        size="small"
                        fullWidth
                        {...getInputProps({
                          placeholder: 'Search Places ...',
                          className: 'location-search-input',
                        })}
                      />
                    )}
                    <div className="autocomplete-dropdown-container">
                      {loading && <div>Loading...</div>}
                      {suggestions?.map((suggestion, i) => {
                        const className = suggestion.active
                          ? 'suggestion-item--active'
                          : 'suggestion-item';
                        // inline style for demonstration purpose
                        const style = suggestion.active
                          ? {
                            backgroundColor: '#fafafa',
                            cursor: 'pointer',
                          }
                          : {
                            backgroundColor: '#ffffff',
                            cursor: 'pointer',
                          };
                        return (
                          <div
                            key={i}
                            {...getSuggestionItemProps(suggestion, {
                              className,
                              style,
                            })}
                          >
                            <span>{suggestion.description}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}
            </PlacesAutocomplete>

            {/* placeauto complete component */}
            {/* <PlacesAutocompleteComponent storeAddress={store_address}/> */}

            <div className="my-4 inputs_n_label">
              <label htmlFor="store_phone">{category === 'brand' ? 'Business Phone' : 'Store Phone'}</label>
              <TextField
                type="text"
                value={storePhone}
                onChange={handleStorePhoneChange}
                id="store_phone"
                placeholder={'+234 xxx xxx xxxx.'}
                size="small"
                fullWidth
              />
            </div>

            {category === 'brand' && (
              <div className="my-4 inputs_n_label">
                <label htmlFor="product_categories">Product Categories*</label>
                <LiveSelect
                  id="product_categories"
                  isMulti
                  options={productCategories.map((cat) => ({ 
                    label: cat.category_name, 
                    value: cat._id 
                  }))}
                  onChange={handleProductCategoryChange}
                  value={selectedProductCategories}
                  placeholder={isLoadingCategories ? "Loading categories..." : "Select product categories..."}
                  isLoading={isLoadingCategories}
                  isDisabled={isLoadingCategories}
                />
                <small style={{ color: '#666' }}>
                  Select the product categories your business manufactures
                </small>
              </div>
            )}

            <div className="my-4 inputs_n_label">
                <label htmlFor="country">Country</label>
                <Select
                    id="country"
                    value={country}
                    onChange={handleCountryChange}
                    fullWidth
                    size="small"
                    displayEmpty
                >
                    <MenuItem value="" disabled>Select Country</MenuItem>
                    {hardcodedCountries.map((c, i) => (
                        <MenuItem key={i} value={c.name}>{c.name}</MenuItem>
                    ))}
                </Select>
            </div>

            <div className="my-4 inputs_n_label">
                <label htmlFor="state">State</label>
                <Select
                    id="state"
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                    fullWidth
                    size="small"
                    displayEmpty
                    disabled={!country}
                >
                    <MenuItem value="" disabled>Select State</MenuItem>
                    {states.map((s, i) => (
                        <MenuItem key={i} value={s}>{s}</MenuItem>
                    ))}
                </Select>
            </div>

            <div className="my-4 inputs_n_label">
                <label htmlFor="bank">Bank (Optional)</label>
                <LiveSelect
                    id="bank"
                    options={banks.map((bank) => ({ label: bank.name, value: bank.code }))}
                    onChange={handleBankChange}
                    value={selectedBank}
                    placeholder="Select or type to search..."
                />
            </div>

            <div className="my-4 inputs_n_label">
                <label htmlFor="account_number">Account Number (Optional)</label>
                <TextField
                    type="text"
                    value={accountNumber}
                    onChange={(e) => setAccountNumber(e.target.value)}
                    id="account_number"
                    placeholder={'Enter 10-digit account number'}
                    size="small"
                    fullWidth
                    disabled={!bankCode}
                />
            </div>

            <div className="my-4 inputs_n_label">
                <label htmlFor="account_name">Account Name (Optional)</label>
                <TextField
                    type="text"
                    value={accountName}
                    id="account_name"
                    placeholder={'Account name will appear here'}
                    size="small"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                      endAdornment: isResolvingAccount && <CircularProgress size="1rem" />
                    }}
                />
            </div>
            
            <div className="my-4 inputs_n_label">
              <label htmlFor="password">Password</label>
              <TextField
                type={showText ? 'text' : 'password'}
                value={password}
                onChange={handlePasswordChange}
                id="password"
                placeholder="Create a password"
                size="small"
                fullWidth
              />
              <div className="icon" onClick={changeType}>
                {!showText && <img src="/assets/icons/eye.svg" alt="" />}
                {showText && <img src="/assets/icons/eye-off.svg" alt="" />}
              </div>
              <small>Enter at least 8 characters</small>
            </div>
            <div className="my-4 inputs_n_label">
              <label htmlFor="c_pass">Confirm password</label>
              <TextField
                type={showText1 ? 'text' : 'password'}
                value={confirm_password}
                onInput={handleCPasswordChange}
                id="c_pass"
                placeholder={!StoreID ? 'Confirm password' : 'Re-type password'}
                size="small"
                fullWidth
              />
              <div className="icon mt-2" onClick={changeType1}>
                {!showText1 && <img src="/assets/icons/eye.svg" alt="" />}
                {showText1 && <img src="/assets/icons/eye-off.svg" alt="" />}
              </div>

              {doesNotMath && (
                <small className="text-danger">
                  Password confirmation does not match
                </small>
              )}
            </div>
            {StoreID && (
              <div className="my-4 inputs_n_label">
                <label htmlFor="c_pass">Store ID</label>
                <TextField
                  disabled
                  value={StoreIDValue}
                  id="c_pass"
                  size="small"
                  fullWidth
                />
              </div>
            )}
            {/* Terms and Conditions Checkbox - always visible and responsive */}
            <div className="termsRow">
             
              <label htmlFor="agree" className="termsLabel">
              <input
                id="agree"
                checked={agree}
                onChange={handleChange2}
                type="checkbox"
                className="termsCheckbox mr-2"
              />
                 I agree with the
                <span
                  onClick={TandC}
                  style={{ fontWeight: 'bold', color: 'royalblue', cursor: 'pointer', marginLeft: 4 }}
                >
                  terms of the service and conditions
                </span>
              </label>
            </div>
            <div className={styles.buttons}>
              {!isPending && (
                <button
                  disabled={!agree}
                  className={`btn btn-block ${styles.btn_custom_color}`}
                >
                  <span className={`${styles.span}`}>Get started</span>
                </button>
              )}
              {isPending && (
                <button
                  disabled
                  className={`btn btn-block ${styles.btn_custom_color}`}
                >
                  Signing you in &nbsp;
                  {isPending && (
                    <CircularProgress style={{ color: 'white' }} size="1rem" />
                  )}
                </button>
              )}
              {/* <button disabled={!agree} className={`${styles.btn_g} btn btn-block`}>
                  <img src="/assets/icons/Social icon.svg" alt="" /> Sign up with Google
                </button> */}
              {/* <GoogleLogin
                  clientId="340631171197-uh0pu11osn3ignruem9mg9vl2sfdrgg7.apps.googleusercontent.com"
                  buttonText="Sign in with Google"
                  onSuccess={responseGoogle}
                  onFailure={responseGoogle}
                  cookiePolicy={'single_host_origin'}
                /> */}
              <p className="text-center">
                Already have an account?{' '}
                <RouterLink to="/login">Sign in</RouterLink>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
